import { Badge } from '@/components/ui/badge'
import {
  aggregateMetadata,
  categoryLabel,
  formatEvidenceValue,
  receiptLabel,
  titleize,
} from '@/components/deals/evidence/evidence-presentation'

export function MarketEvidenceSummary({ category }) {
  const aggregates = category.providerAggregates ?? []
  const receipts = category.sourceReceipts ?? []

  return (
    <article className="rounded-lg border border-border bg-background p-4">
      <div className="flex flex-wrap items-start justify-between gap-2">
        <h5 className="font-semibold text-foreground">{categoryLabel(category.category)}</h5>
        <div className="flex flex-wrap gap-2">
          <Badge variant="outline">{titleize(category.coverage)}</Badge>
          <Badge variant="secondary">{titleize(category.freshness)}</Badge>
        </div>
      </div>

      {aggregates.length > 0 ? (
        <div className="mt-3 space-y-3">
          {aggregates.map((aggregate) => (
            <div
              key={[
                aggregate.label || 'aggregate',
                aggregate.value,
                aggregate.period,
                aggregate.area_unit || aggregate.areaUnit,
                aggregate.basis,
              ].filter(Boolean).join('-')}
            >
              {aggregate.label ? <p className="text-xs text-muted-foreground">{aggregate.label}</p> : null}
              <p className="text-xl font-bold text-foreground">
                {formatEvidenceValue(category.category, aggregate)}
              </p>
              {aggregateMetadata(aggregate) ? (
                <p className="text-xs text-muted-foreground">{aggregateMetadata(aggregate)}</p>
              ) : null}
            </div>
          ))}
        </div>
      ) : (
        <p className="mt-3 text-sm text-muted-foreground">No supported values available.</p>
      )}

      {(category.limitations ?? []).length > 0 ? (
        <ul className="mt-3 list-disc space-y-1 pl-4 text-xs text-muted-foreground">
          {category.limitations.map((limitation) => (
            <li key={limitation}>{titleize(limitation)}</li>
          ))}
        </ul>
      ) : null}

      {receipts.length > 0 ? (
        <p className="mt-3 text-xs text-muted-foreground">{receipts.map(receiptLabel).join(' · ')}</p>
      ) : null}
    </article>
  )
}
